import { createContext, useContext } from 'react';
import type { useSessionLifecycle } from '@/hooks/useSessionLifecycle';
import type { useAgentActions } from '@/hooks/useAgentActions';
import type { useArtifactState } from '@/hooks/useArtifactState';

interface SessionContextValue {
  session: ReturnType<typeof useSessionLifecycle>;
  actions: ReturnType<typeof useAgentActions>;
  artifacts: ReturnType<typeof useArtifactState>;
  agentError: string | null;
  dismissAgentError: () => void;
}

const SessionContext = createContext<SessionContextValue | null>(null);

export const SessionProvider = SessionContext.Provider;

export const useAppSession = () => {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useAppSession must be used within SessionProvider');
  return ctx;
};
